import { CornSchema } from '@eigtech/shared-corn';
import { z } from 'zod';
export const ChimeMeetingSchema = z.object({
    chimeMeetingId: z.string().optional(),
    entityId: CornSchema,
    activeAttendees: z.array(z.string()).optional(),
    meetingId: z.string(),
    meetingStartTime: z.string(),
    meeting: z.record(z.string(), z.unknown()),
});
